<template>
	<div id="aemLimitedAccessModal">
		<div>
			<div
				id="limitedAccessModal"
				tabindex="-1"
				role="dialog"
				aria-labelledby="limitedAccessModalLabel"
				:aria-hidden="!show"
				class="modal fade"
				:class="{ in: show }"
				:style="{ display: showBackdrop ? 'block' : 'none' }"
				@click="closeModal"
			>
				<div role="document" class="modal-dialog modal-lg" @click.stop>
					<div class="modal-content">
						<div class="modal-header">
							<button
								type="button"
								data-dismiss="modal"
								aria-label="Close"
								class="close"
								@click="closeModal"
							>
								<span aria-hidden="true">×</span>
							</button>
							<h1 id="limitedAccessModalLabel" class="h3 modal-title">Limited Account</h1>
						</div>
						<div class="modal-body">
							<p>
								You're logging in with an account not associated with an active membership and will
								have limited access to content.
							</p>
							<p>
								If you are an active member, please verify you're using the correct credentials.
							</p>
							<p>
								For additional assistance, please call <a href="tel:888-430-6432">888-430-6432</a>.
							</p>
						</div>
						<div class="modal-footer">
							<button
								id="limitedAccessModalCloseButton"
								type="button"
								data-dismiss="modal"
								class="btn btn-primary btn-sm"
								@click="closeModal"
							>
								OK
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="modal-backdrop fade"
		:class="{ in: show }"
		:style="{ display: showBackdrop ? 'block' : 'none' }"
	></div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { storageService } from '@/lib/services/storageService';

// matches value in lt-aem repo
const dismissedLimitedAccessModal = 'lt-dismissed-limited-access-notification';

// A couple variables are used because this combined with setTimeout allows CSS animations to be seen
const show = ref(false); // whether modal is shown (applies CSS class that controls in/out animation)
const showBackdrop = ref(false); // whether overlay covers screen

onMounted(() => {
	window.ef.eventHub.on('ef-framework-loaded', async () => {
		const mmsFailureFlag = 'mmsFailure'; // matches value in lt-aem repo
		const limitedAccountModalFeature = 'limitedaccountmodal';
		if (!window.ef.profileStore) return;
		const features = window.lt?.features || [];
		const hasLimitedAccessModalFlag = features.some(
			(e) => e.featureId === limitedAccountModalFeature && e.enabled === true
		);
		const isLoginPage = Boolean(document.querySelector('.login-panel'));
		// Regex for paths that have `/confirmation/` then 1 or more characters ending with `.html`
		const confirmationPageRegex = /\/confirmation\/.+\.html$/;
		const isConfirmationPage = confirmationPageRegex.test(window.location.pathname);
		const notMmsFailure = window.localStorage.getItem(mmsFailureFlag) !== 'true';
		if (hasLimitedAccessModalFlag && !isLoginPage && !isConfirmationPage && notMmsFailure) {
			const profile = await getProfileData();

			if (
				profile &&
				profile.memberDetails &&
				(profile.memberDetails.membershipStatus === 'Terminated' ||
					profile.memberDetails.memberId === 0) &&
				!storageService.sessionGet(dismissedLimitedAccessModal)
			) {
				// backdrop is displayed immediately, while modal is delayed
				// so fade-in animation is visible
				showBackdrop.value = true;
				setTimeout(() => {
					show.value = true;
				}, 300);
			}
		}
	});
});

const closeModal = () => {
	// modal is removed immediately but backdrop remains for a short time so
	// fade-out animation is visible
	show.value = false;
	setTimeout(() => {
		showBackdrop.value = false;
	}, 300);
	storageService.sessionSet(dismissedLimitedAccessModal, true);
};

const getProfileData: () => any = () =>
	new Promise((resolve) => {
		getProfile()?.initialized
			? resolve(getProfile())
			: window.ef.eventHub.on('ef-framework-loaded', () => resolve(getProfile()));
	});

const getProfile = () => window.ef.profileStore.getInitialData();
</script>
